import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useQuery } from "@tanstack/react-query";
import { Mapper } from "@/common/services/mapper";

type UseNotificationsConfigurationsProps<T> = {
  mapper?: (data: any) => T,
}

export const useNotificationsConfigurations = <T,>({
  mapper = Mapper.default<T>(),
}: UseNotificationsConfigurationsProps<T>) => {
  const privateAxios = usePrivateAxios();

  return useQuery({
    queryKey: ['notificationConfigurations'],
    queryFn: () => privateAxios.get(`/notification_configurations`),
    select: (data) => mapper(data?.data?.data),
  });
}
